module.exports = __webpack_public_path__ + "static/media/landing-bg-mobile.45f647a1.png";